module.exports = __webpack_public_path__ + "static/media/plantyn_logo.6012b69e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plantyn_logo.svg
// module id = 23
// module chunks = 0